module.exports = __webpack_public_path__ + "assets/platform-quadrado.ff62dd78.svg";